import React, { useEffect, useState } from 'react';
import EditClaimEstateModal from '../components/edit-claim-modal/Modal';
import { getClaims, getClaimsReport } from '../../../services/claim';
import { get, set } from '../../../services/storage';
import ClaimUpdatesListModal from './claim-updates-list-modal/Modal';
import CreateClaimEstateModal from './create-claim-modal/Modal';
import {
  Dimmer,
  Table,
  Segment,
  Loader,
  Label,
  Popup,
  Menu,
  Icon,
  Grid,
  Input,
  Dropdown,
  Checkbox,
  Confirm
} from 'semantic-ui-react';
import { iRootDispatch, iRootState } from '../../../store';
import { connect } from 'react-redux';
import { AvailableBrokersAndEstatesState } from '../../../store/types/temp-types';
import CustomDatePicker from '../../../components/CustomDatePicker';
import AppMaskedInput from '../../../components/MaskedInput';
import { CustoDropDownItemProps } from '../types/CustoDropDownItem';
import { DATE_INPUT_MASK, maskCpfOrCnpj } from '../../../services/masks';
import DetailModal from './DetailModal';
import styled from 'styled-components';
import { translateStatus, translatePropertyStatus } from '../util';
import ModalAttachFiles from '../../../components/ModalAttachFiles';
import { FileIdentifiersAll } from '../types/FileIdentifiersClaimEstate.enum';
import { UserRolesEnum } from '../../../enums/user-roles.enum';
import { useDropDownUsers } from '../../../services/broker';
import moment from 'moment-timezone';
import { sendMessage, sendWebhookFiles } from '../../../services/followup';
import AuthorizationContainer from '../../../components/AuthorizationContainer';
import { ActionEnum } from '../../../enums/authz-action.enum';
import { FeatureEnum } from '../../../enums/authz-feature.enum';
import { useLocation } from 'react-router-dom';
import { ClaimEstatesStatusEnum } from '../types/ClaimEstatesStatusEnum';
import { Field, Formik, FormikProps } from 'formik';
import { extractApiErrorMessages } from '../../../utils/apiErrorHandler';
import { ChecklistContainer } from '../../estates-preregister-list/styles';
import { DateContainer, EndDate, StartDate } from '../../../styles';
import { dangerNotification, successNotification } from '../../../services/notification';
import { deleteClaimDraft } from '../../../services/claims';
// import * as Sentry from '@sentry/react';
import { ReportModal } from '../../../components/ReportModal';
import IconButton from '../../../components/IconButton';
import TablePaginationMenu from '../../../components/TablePaginationMenu';
import EstateUnitFilter from '../../../components/EstateUnitFilter';
import { getListEmptyMessage } from '../../../utils/estateUnitEmptyState.util';
import { ClaimFilterStatus } from '../types/ClaimFilterStatusTypes';
import Button from '../../../components/Button';
import VacatePropertyClaimModal from './vacate-property-claim-modal/Modal';
import { getFileIdentifiers } from './create-claim-modal/utils';
import { ClaimPropertyStatusEnum } from '../../../enums/claim-property-status.enum';
import { CreateClaimEstateInitialInitialValuesType } from './create-claim-modal/Formik/types/CreateClaimEstateInitialValuesTypes';
import PopupModal from '../../../components/PopupModal';
import { BannerLocationActivationEnum } from '../../../types/Banner';
import { PolicyForGetBondInsurancePoliciesListResponseDTO } from '../../../dtos/bond-insurance-policy-list/interfaces/policy-for-get-bond-insurance-policies-list-response-dto';
import SetEstateResponsibleModal from './SetEstateResponsibleModal';
import { getUsers } from '../../../services/estate';
import { UserState } from '../../../types/UserState';

interface LocationState {
  claimId?: string;
  openEditModal?: boolean;
  openCreateClaimModal?: boolean;
  selectedPolicyForClaim?: PolicyForGetBondInsurancePoliciesListResponseDTO;
}

const ClickableTableCell = styled(Table.Cell)`
  cursor: pointer;
  position: relative;
`;

const ClickableTableRow = styled(Table.Row)`
  :hover {
    background-color: #f0f0f0;
  }
`;

const ClickableTableHeader = styled(Table.HeaderCell)`
  cursor: pointer !important;

  :hover {
    background-color: #f0f0f0 !important;
  }
`;

export const FieldLabel = styled.label<{ paddingTop?: boolean }>`
  font-weight: bold;
  padding-top: ${props => (props.paddingTop ? '14px' : '0px')};
  text-transform: uppercase;
  margin-left: 5px;
`;

export const FieldValue = styled.p`
  padding-left: 5px;
`;

const FilteredColumn = styled(Grid.Column)<{ borderLeft?: boolean }>`
  padding: 5px;
  cursor: pointer;
  border-left: ${props => (props.borderLeft ? '1px solid #aaa' : '0')};
`;

export const LabelBadge = styled.div<{ color: string }>`
  display: inline-block;
  background-color: ${props => props.color};
  border-radius: 15px;
  padding: 0.5833em 0.833em;
  width: 40px;
  line-height: 9px;
  font-size: 13px;
`;

export const SpanNumBadge = styled.span<{ checked: boolean }>`
  padding-left: 4px;
  color: ${props => (props.checked ? 'black' : 'gray')};
`;

export const DivTextBadge = styled.div<{ checked: boolean }>`
  padding-top: 2px;
  color: ${props => (props.checked ? 'black' : '#aaa')};
`;

const mapState = (state: iRootState) => ({
  availableBrokersAndEstates: state.availableBrokersAndEstates,
  user: state.user
});

const mapDispatch = (dispatch: iRootDispatch) => ({
  updateAvailableBrokersAndEstates: (availableBrokers: AvailableBrokersAndEstatesState) =>
    dispatch.availableBrokersAndEstates.updateAvailableBrokersAndEstates(availableBrokers)
});

const ClaimTable = (props: any) => {
  const [isClaimUpdatesListModalIsOpen, setClaimUpdatesListModalIsOpen] =
    useState<boolean>(false);
  const [isEditModalIsOpen, setEditModalIsOpen] = useState<boolean>(false);
  const [id, setId] = useState('');
  const userId = get('uid');

  const claimPropertiesStatusEnum = [
    {
      index: 0,
      value: 'null',
      text: 'Todos'
    },
    {
      index: 1,
      value: 'OCCUPIED',
      text: 'Ocupado'
    },
    {
      index: 2,
      value: 'VACANT',
      text: 'Desocupado'
    }
  ];

  const claimEstatesStatusEnum = [
    {
      index: 11,
      value: 'DRAFT',
      text: 'Rascunho'
    },
    {
      index: 10,
      value: 'RETURN_BILL',
      text: 'Boleto Devolutivo'
    },
    {
      index: 5,
      value: 'DEBT_CONFESSION',
      text: 'Confissão de Dívida'
    },
    {
      index: 0,
      value: 'CREATED',
      text: 'Em aberto'
    },
    {
      index: 6,
      value: 'IN_ACCORD',
      text: 'Em acordo'
    },
    {
      index: 1,
      value: 'IN_ANALYSIS',
      text: 'Em análise'
    },
    {
      index: 2,
      value: 'IN_PROGRESS',
      text: 'Em andamento'
    },
    {
      index: 4,
      value: 'FINISHED',
      text: 'Finalizado'
    },
    {
      index: 7,
      value: 'MONTHLY_INDEMNITY',
      text: 'Indenizado mensalmente'
    },
    {
      index: 8,
      value: 'LMI_LMG_REACHED',
      text: 'LMI/LMG atingido'
    },
    {
      index: 3,
      value: 'PENDING',
      text: 'Pendenciado'
    },
    {
      index: 9,
      value: 'PRE_ACCIDENT',
      text: 'Pré-sinistro'
    }
  ];

  const TYPE_OPTIONS = [
    {
      index: 1,
      value: 'name',
      text: 'Nome do locatário'
    },
    {
      index: 2,
      value: 'document',
      text: 'CPF ou CNPJ'
    },
    {
      index: 3,
      value: 'address',
      text: 'Endereço do imóvel'
    },
    {
      index: 4,
      value: 'claimCode',
      text: 'Código do sinistro'
    },
    {
      index: 5,
      value: 'processNumber',
      text: 'Número do processo'
    },
    {
      index: 6,
      value: 'policyNumber',
      text: 'Número da apólice'
    },
    {
      index: 7,
      value: 'propertyCode',
      text: 'Código do imóvel'
    }
  ];

  const { availableBrokersAndEstates, user } = props;
  const estates: CustoDropDownItemProps[] = availableBrokersAndEstates.estates;
  const allInsurers: CustoDropDownItemProps[] = availableBrokersAndEstates.insurers.map(
    (insurer: any) => ({
      index: insurer.value.id,
      value: insurer.value.id,
      text: insurer.value.name
    })
  );

  const insurers: CustoDropDownItemProps[] = allInsurers.concat({
    key: '297c0ed6-a9ea-48d3-b0da-235597ae9f7a',
    value: '297c0ed6-a9ea-48d3-b0da-235597ae9f7a',
    text: 'Liberty Seguros'
  } as any);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [responsibleOptions, setResponsibleOptions] = useState<CustoDropDownItemProps[]>(
    []
  );
  const [estateResponsibleOptions, setEstateResponsibleOptions] = useState<
    CustoDropDownItemProps[]
  >([]);
  const [isEstateResponsibleLoading, setIsEstateResponsibleLoading] =
    useState<boolean>(false);
  const [openSetEstateResponsible, setOpenSetEstateResponsible] =
    useState<boolean>(false);
  const [insurersOptions, setInsurersOptions] = useState<CustoDropDownItemProps[]>([]);
  const [estatesOptions, setEstatesOptions] = useState<CustoDropDownItemProps[]>([]);
  const [selectedItem, setSelectedItem] = useState<any>({});
  const [data, setData] = useState<any[]>([]);
  const [count, setCount] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [isBlocked, setIsBlocked] = useState(false);
  const [openDetail, setOpenDetail] = useState<boolean>(false);
  const location = useLocation();
  const initialClaimId = (location.state as LocationState)?.claimId;
  const [claimId, setClaimId] = useState<any>(initialClaimId);
  const initialOpenEditModal = (location.state as LocationState)?.openEditModal;
  const [openEditModal, setOpenEditModal] = useState<any>(initialOpenEditModal);
  const initialOpenCreateClaimModal = (location.state as LocationState)?.openCreateClaimModal;
  const initialSelectedPolicyForClaim = (location.state as LocationState)
    ?.selectedPolicyForClaim;
  const [openCreateClaimModal, setOpenCreateClaimModal] = useState<boolean>(
    Boolean(initialOpenCreateClaimModal && initialSelectedPolicyForClaim)
  );
  const [selectedPolicyForClaim, setSelectedPolicyForClaim] =
    useState<PolicyForGetBondInsurancePoliciesListResponseDTO | null>(
      initialSelectedPolicyForClaim || null
    );
  const [draftIdToResume, setDraftIdToResume] = useState<string | null>(null);
  const [draftToDelete, setDraftToDelete] = useState<string | null>(null);
  const [isDeletingDraft, setIsDeletingDraft] = useState(false);
  const [cloneIdToClone, setCloneIdToClone] = useState<string | null>(null);
  const [filters, setFilters] = useState<any>({});
  const [estateUnitIdFilter, setEstateUnitIdFilter] = useState('');
  const [reportModalIsOpen, setReportModalIsOpen] = useState<boolean>(false);
  const [reportState, setReportState] = useState<number | undefined>(undefined);
  const [sortColumn, setSortColumn] = useState<string | null>('createdAt');
  const [sortDirection, setSortDirection] = useState<'ASC' | 'DESC'>('DESC');
  const [statusCount, setStatusCount] = useState<ClaimFilterStatus>({
    countNew: undefined,
    countUnread: undefined,
    countOld: undefined,
    countDraft: undefined
  });
  const [openVacateModal, setOpenVacateModal] = useState<boolean>(false);
  const [claimVacate, setClaimVacate] = useState<{
    id: string;
    insurerName: string;
  } | null>(null);

  const normalizeFilters = async (filters: any) => {
    const validFilters: any = {};

    for (const key in filters) {
      if (filters[key] === '' || key === 'argument') {
        continue;
      }

      if (key === 'start' || key === 'end') {
        validFilters[key] = moment(filters[key]).format('YYYY-MM-DD');
        continue;
      }

      if (key === 'type') {
        validFilters[filters[key]] = filters['argument'];
        continue;
      }

      validFilters[key] = filters[key];
    }

    return validFilters;
  };

  const handleReportModalClose = () => {
    setReportModalIsOpen(false);
  };

  const handleOpen = () => {
    setClaimUpdatesListModalIsOpen(true);
  };

  const {
    data: users,
    isLoading: isResponsibleLoading,
    isError
  } = useDropDownUsers(userId ?? '');

  useEffect(() => {
    if (isError) {
      dangerNotification('Ops...', 'Erro ao carregar campo responsável.');
    }

    if (users && !isError) {
      const nonResponsible = {
        key: 0,
        value: 'null',
        text: 'Não Atribuído'
      };

      const newUsers = users.map((user: any) => {
        const { id, name } = user;

        const returnUser: CustoDropDownItemProps = {
          key: id,
          value: id,
          text: name
        };

        return returnUser;
      });

      const finalUsers = [nonResponsible, ...newUsers];

      setResponsibleOptions(finalUsers);
    }
  }, [users, isError]);

  useEffect(() => {
    const loadEstateResponsibleOptions = async () => {
      if (!user.role.includes('ESTATE')) {
        return;
      }

      const estateId =
        user?.estate?.id || availableBrokersAndEstates?.activeEstateId;

      if (!estateId) {
        return;
      }

      setIsEstateResponsibleLoading(true);
      try {
        const estateUsers = await getUsers(estateId);
        const options = estateUsers.map((estateUser: UserState, index: number) => ({
          key: index + 1,
          value: estateUser.id,
          text: estateUser.name
        }));

        setEstateResponsibleOptions([
          {
            key: 0,
            value: 'null',
            text: 'Sem responsável'
          },
          ...options
        ]);
      } catch (error) {
        dangerNotification('Ops...', 'Erro ao carregar responsáveis da imobiliária.');
      } finally {
        setIsEstateResponsibleLoading(false);
      }
    };

    loadEstateResponsibleOptions();
  }, [user, availableBrokersAndEstates?.activeEstateId]);

  const getCountData = async () => {
    const normalizedFilters = await normalizeFilters(filters);
    const filtersData: any = {
      page: currentPage,
      userId,
      isRv: true,
      onlyCount: true,
      ...normalizedFilters,
      ...(estateUnitIdFilter ? { estateUnitId: estateUnitIdFilter } : {})
    };

    const dataNew = await getClaims({ filters: { ...filtersData, isNew: true } });
    const dataUnread = await getClaims({ filters: { ...filtersData, isUnread: true } });
    const dataOld = await getClaims({ filters: { ...filtersData, isOld: true } });
    const dataDraft = await getClaims({
      filters: { ...filtersData, claimEstateStatus: 'DRAFT' }
    });

    setStatusCount({
      countNew: dataNew.count,
      countUnread: dataUnread.count,
      countOld: dataOld.count,
      countDraft: dataDraft.count
    });
  };

  const getData = async () => {
    setIsLoading(true);
    const normalizedFilters = await normalizeFilters(filters);
    const filtersData: any = {
      page: currentPage,
      userId,
      isRv: true,
      ...normalizedFilters,
      ...(estateUnitIdFilter ? { estateUnitId: estateUnitIdFilter } : {})
    };

    const claims =
      claimId !== undefined
        ? await getClaims({ id: claimId, filters: filtersData })
        : await getClaims({
            filters: filtersData,
            sortColumn: sortColumn,
            sortDirection: sortDirection
          });

    if (claimId) {
      setData([
        {
          id: claims.id,
          createdAt: claims.createdAt,
          status: claims.status,
          insurerName: claims.insurer?.name,
          estateName: claims.estate?.name,
          tenantName: claims.claimTenant?.fullName,
          tenantDocument: claims.claimTenant?.document,
          propertyStreet: claims.claimProperty?.street,
          propertyNumber: claims.claimProperty?.number,
          propertyComplement: claims.claimProperty?.complement,
          propertyDistrict: claims.claimProperty?.district,
          propertyCity: claims.claimProperty?.street,
          propertyState: claims.claimProperty?.state,
          propertyStatus: claims.claimProperty?.status,
          responsibleName: claims.responsible?.name,
          unreadMessagesCount:
            claims.messages?.filter((message: any) => {
              const isUnread = !message.viewed && message.senderId?.id !== userId;
              const isUserEstateRole =
                user.role === UserRolesEnum.estateAdmin ||
                user.role === UserRolesEnum.estateUser;
              const isSenderEstateRole =
                message.senderId?.role === UserRolesEnum.estateAdmin ||
                message.senderId?.role === UserRolesEnum.estateUser;

              return (
                isUnread &&
                ((isUserEstateRole && !isSenderEstateRole) ||
                  (!isUserEstateRole && isSenderEstateRole))
              );
            })?.length || 0
        }
      ]);
      setCount(1);
    } else {
      setData(claims.data);
      if (currentPage === 1) setCount(claims.count);
    }

    setIsLoading(false);
    setClaimId(undefined);
  };

  const handleClose = () => {
    setClaimUpdatesListModalIsOpen(false);
    setSelectedItem(null);
    setEditModalIsOpen(false);
    getData();
    getCountData();
  };

  const handleExportData = async (values: any) => {
    if (values.claimEstateStatus === '' && (values.start === '' || values.end === '')) {
      dangerNotification(
        'Ops...',
        'Selecione ao menos o filtro de Status ou um período na Data de cadastro.'
      );
      return;
    }

    if (values.start !== '' && values.end !== '') {
      const startDate = moment(values.start).format('YYYY-MM-DD');
      const endDate = moment(values.end).format('YYYY-MM-DD');

      if (moment(startDate).isAfter(endDate)) {
        dangerNotification(
          'Ops...',
          'A data de início não pode ser maior que a data de fim.'
        );
        return;
      }

      if (moment(endDate).diff(moment(startDate), 'years') > 0) {
        dangerNotification(
          'Ops...',
          'O intervalo entre as datas não pode ser maior que 1 ano'
        );
        return;
      }
    }

    setIsLoading(true);

    try {
      const normalizedFilters = await normalizeFilters(filters);
      const filtersData: any = {
        page: currentPage,
        userId,
        ...normalizedFilters,
        ...(estateUnitIdFilter ? { estateUnitId: estateUnitIdFilter } : {})
      };

      const status = await getClaimsReport({ filters: { ...filtersData, isRv: true } });

      if (!status) {
        dangerNotification('Ops...', 'Erro ao solicitar relatório de sinistros.');
      } else {
        setReportState(status);
        setReportModalIsOpen(true);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClaimUpdatesList = (id: string, item: any, status: string) => {
    setId(id);
    setSelectedItem(item);
    setClaimUpdatesListModalIsOpen(true);
    setIsBlocked(status === 'FINISHED');
  };

  const handleEdit = (id: string) => {
    setId(id);
    setEditModalIsOpen(true);
  };

  const handleConfirmDeleteDraft = async () => {
    if (!draftToDelete) return;

    setIsDeletingDraft(true);
    try {
      await deleteClaimDraft(draftToDelete);
      successNotification(
        'Sucesso',
        'Rascunho excluído com sucesso. Ele não aparecerá mais na plataforma nem nos lembretes por e-mail.'
      );
      setDraftToDelete(null);
      await getData();
      await getCountData();
    } catch (err) {
      const message = extractApiErrorMessages(
        err,
        'Não foi possível excluir o rascunho.'
      );
      dangerNotification('Erro', message);
    } finally {
      setIsDeletingDraft(false);
    }
  };

  const openDetailModal = (id: string) => {
    setId(id);
    setOpenDetail(true);
  };

  async function callback(fileTypes: string[], files: any[], claim_id: string) {
    if (fileTypes) {
      let message = 'Foram anexados os seguintes arquivos: ';
      message += `${fileTypes.join(', ')}.`;
      try {
        await sendMessage(claim_id, user.id, message, user.name);
        if (
          user.role === UserRolesEnum.estateAdmin ||
          user.role === UserRolesEnum.estateUser
        ) {
          await sendWebhookFiles(claim_id, files);
        }
      } catch (err) {
        dangerNotification(
          'Erro',
          'Erro ao enviar notificação de followup, por favor, envie manualmente.'
        );
        // Sentry.captureException(err, {
        //   tags: {
        //     page: 'claim_estates/components/Table.tsx',
        //     claimId: claim_id,
        //     user: user,
        //     fileTypes: fileTypes ? fileTypes.join(', ') : 'undefined',
        //   }
        // });
      }
    } else {
      await sendMessage(claim_id, user.id, 'Arquivos foram anexados', user.name);
    }
  }

  const handleChangeBadge = async (type: string) => {
    setIsLoading(true);
    const filterProp = {
      isNew: false,
      isUnread: false,
      isOld: false,
      claimEstateStatus: ''
    };
    switch (type) {
      case 'new':
        filterProp.isNew = true;
        break;
      case 'unread':
        filterProp.isUnread = true;
        break;
      case 'old':
        filterProp.isOld = true;
        break;
      case 'draft':
        filterProp.claimEstateStatus = 'DRAFT';
        break;
    }

    try {
      setFilters({
        ...filters,
        ...filterProp
      });
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearchFormSubmit = async (filters: any) => {
    setCurrentPage(1);
    setFilters(filters);
  };

  const handleVacate = (id: string, insurerName: string) => {
    setClaimVacate({ id, insurerName });
    setOpenVacateModal(true);
  };

  useEffect(() => {
    if (!!estates.length) {
      getData();
    }
  }, [currentPage, estates, filters, sortColumn, sortDirection]);

  useEffect(() => {
    getCountData();
  }, []);

  useEffect(() => {
    if (!insurersOptions.length) {
      const insurersOptions = insurers.map((insurer: any) => ({
        key: insurer.index,
        value: insurer.value,
        text: insurer.text
      }));

      setInsurersOptions(insurersOptions);
    }

    if (!estatesOptions.length) {
      const estatesOptions = estates.map((estate: any) => ({
        key: estate.value.id,
        value: estate.value.id,
        text: estate.text
      }));

      setEstatesOptions(estatesOptions);
    }
  }, [availableBrokersAndEstates, estates, estatesOptions, insurers, insurersOptions]);

  useEffect(() => {
    window.history.replaceState(
      {
        ...(location.state as any),
        claimId: undefined,
        openCreateClaimModal: undefined,
        selectedPolicyForClaim: undefined
      },
      ''
    );
  }, [location]);

  useEffect(() => {
    if (openEditModal && claimId) {
      handleEdit(claimId);
    }
  }, [openEditModal, claimId]);

  const SortableHeaderCell = ({
    columnKey,
    children
  }: {
    columnKey: string;
    children: React.ReactNode;
  }) => {
    const isActive = sortColumn === columnKey;
    const indicator = isActive ? (
      <IconButton
        name={
          sortDirection === 'ASC'
            ? 'long arrow alternate up'
            : 'long arrow alternate down'
        }
      />
    ) : null;

    const handleSort = () => {
      if (isActive) {
        setSortDirection(sortDirection === 'ASC' ? 'DESC' : 'ASC');
      } else {
        setSortColumn(columnKey);
        setSortDirection('ASC');
      }
    };

    return (
      <ClickableTableHeader textAlign="center" onClick={handleSort}>
        {children} {indicator}
      </ClickableTableHeader>
    );
  };

  const trigger = <IconButton name="ellipsis vertical" />;

  return (
    <>
      <Confirm
        open={!!draftToDelete}
        onCancel={() => setDraftToDelete(null)}
        onConfirm={handleConfirmDeleteDraft}
        cancelButton="Cancelar"
        confirmButton="Excluir rascunho"
        header="Excluir rascunho de sinistro"
        content="Esta ação é irreversível. O rascunho será removido da plataforma e deixará de aparecer nos lembretes por e-mail. Apenas rascunhos podem ser excluídos por aqui."
        size="small"
      />
      {reportModalIsOpen && reportState === 200 ? (
        <ReportModal
          isOpen={reportModalIsOpen}
          header="Relatório de Sinistros"
          message={`
              O relatório será gerado em background e será enviado o link para download via e-mail.
              Atenção, só será possível gerar um novo relatório após a finalização desse.
            `}
          onClose={handleReportModalClose}
        />
      ) : (
        <ReportModal
          isOpen={reportModalIsOpen}
          header="Relatório de Sinistros"
          message="Já existe um relatório na fila para ser gerado, aguarde a notificação via email."
          onClose={handleReportModalClose}
        />
      )}

      {isClaimUpdatesListModalIsOpen && (
        <ClaimUpdatesListModal
          isOpen={isClaimUpdatesListModalIsOpen}
          isBlocked={isBlocked}
          onOpen={handleOpen}
          onClose={handleClose}
          claim={selectedItem}
          header="Atualização do Sinistro"
          id={id}
          user={user}
        />
      )}

      <Formik
        initialValues={{
          type: 'document',
          argument: '',
          claimEstateStatus: '',
          claimPropertyStatus: '',
          start: '',
          end: '',
          estateId: '',
          insurerId: '',
          responsibleId: '',
          estateResponsibleId: '',
          onlyUnread: false
        }}
        onSubmit={async (values, { setSubmitting }) => {
          await handleSearchFormSubmit(values);
          setSubmitting(false);
        }}
      >
        {({
          values,
          errors,
          handleChange,
          handleSubmit,
          setFieldValue,
          handleReset,
          setFieldError,
          setErrors
        }) => (
          <form onSubmit={handleSubmit}>
            <Grid style={{ marginBottom: 20 }}>
              <Grid.Row style={{ paddingBottom: 0 }}>
                <Grid.Column width={3}>
                  <strong>Pesquisar por:</strong>
                  <Dropdown
                    name="type"
                    value={values.type}
                    options={TYPE_OPTIONS}
                    search
                    selection
                    disabled={isLoading}
                    onChange={(e, { value }) => {
                      if (value === '') setFieldValue('argument', value);
                      setFieldValue('type', value);
                    }}
                    clearable
                  />
                </Grid.Column>

                <Grid.Column width={3}>
                  <strong>Termo de pesquisa:</strong>
                  <Input
                    fluid
                    id="argument"
                    name="argument"
                    disabled={isLoading || !values.type}
                    value={values.argument}
                    onChange={handleChange}
                  />
                </Grid.Column>

                <Grid.Column width={3}>
                  <strong>Status:</strong>
                  <Dropdown
                    fluid
                    name="claimEstateStatus"
                    value={values.claimEstateStatus}
                    disabled={isLoading}
                    options={claimEstatesStatusEnum || []}
                    search
                    selection
                    onChange={(e, { value }) => setFieldValue('claimEstateStatus', value)}
                    clearable
                  />
                </Grid.Column>

                <Grid.Column width={3}>
                  <strong>Status do imóvel:</strong>
                  <Dropdown
                    fluid
                    search
                    selection
                    clearable
                    disabled={isLoading}
                    name="claimPropertyStatus"
                    value={values.claimPropertyStatus}
                    options={claimPropertiesStatusEnum || []}
                    onChange={(e, { value }) =>
                      setFieldValue('claimPropertyStatus', value)
                    }
                  />
                </Grid.Column>

                <Grid.Column width={4}>
                  <strong>Data de cadastro:</strong>
                  <DateContainer>
                    <StartDate>
                      <label style={{ paddingRight: 5 }}>De:</label>
                      <Field
                        name="start"
                        selected={values.start}
                        disabled={isLoading}
                        component={CustomDatePicker}
                        onChange={(date: Date) => {
                          if (!date) setFieldValue('end', '');
                          setFieldValue('start', date ?? '');
                        }}
                        customInput={<AppMaskedInput mask={DATE_INPUT_MASK} />}
                        dateFormat={'dd/MM/yyyy'}
                      />
                    </StartDate>
                    <EndDate>
                      <label style={{ paddingRight: 5 }}>Até:</label>
                      <Field
                        name="end"
                        selected={values.end}
                        disabled={isLoading || !values.start}
                        component={CustomDatePicker}
                        onChange={(date: Date) => setFieldValue('end', date ?? '')}
                        customInput={<AppMaskedInput mask={DATE_INPUT_MASK} />}
                        dateFormat={'dd/MM/yyyy'}
                      />
                    </EndDate>
                  </DateContainer>
                </Grid.Column>
              </Grid.Row>

              <Grid.Row style={{ marginTop: 0 }}>
                {!user.role.includes('ESTATE') && (
                  <Grid.Column width={3}>
                    <strong>Imobiliária:</strong>
                    <Dropdown
                      fluid
                      search
                      selection
                      clearable
                      name={'estateId'}
                      disabled={isLoading}
                      value={values.estateId}
                      options={estatesOptions}
                      onChange={(e, { value }) => setFieldValue('estateId', value)}
                    />
                  </Grid.Column>
                )}

                <Grid.Column width={3}>
                  <EstateUnitFilter
                    estateId={String(values.estateId || user.estate?.id || '')}
                    value={estateUnitIdFilter}
                    onChange={setEstateUnitIdFilter}
                  />
                </Grid.Column>

                <Grid.Column width={4}>
                  <strong>Seguradora / Garantidora:</strong>
                  <Dropdown
                    fluid
                    search
                    selection
                    clearable
                    name={'insurerId'}
                    disabled={isLoading}
                    value={values.insurerId}
                    options={insurersOptions}
                    onChange={(e, { value }) => setFieldValue('insurerId', value)}
                  />
                </Grid.Column>

                {!user.role.includes('ESTATE') && (
                  <Grid.Column width={3}>
                    <strong>Responsável:</strong>
                    <Dropdown
                      fluid
                      search
                      selection
                      clearable
                      name="responsibleId"
                      value={values.responsibleId}
                      options={responsibleOptions}
                      loading={isResponsibleLoading}
                      disabled={isLoading}
                      onChange={(e, { value }) => setFieldValue('responsibleId', value)}
                    />
                  </Grid.Column>
                )}

                {user.role.includes('ESTATE') && (
                  <Grid.Column width={3}>
                    <strong>Responsável (Imobiliária):</strong>
                    <Dropdown
                      fluid
                      search
                      selection
                      clearable
                      name="estateResponsibleId"
                      value={values.estateResponsibleId}
                      options={estateResponsibleOptions}
                      loading={isEstateResponsibleLoading}
                      disabled={isLoading}
                      onChange={(e, { value }) =>
                        setFieldValue('estateResponsibleId', value)
                      }
                    />
                  </Grid.Column>
                )}

                <Grid.Column width={2}>
                  <ChecklistContainer>
                    <Checkbox
                      id="onlyUnread"
                      name="onlyUnread"
                      label={'Mensagens não lidas'}
                      style={{ fontSize: 14 }}
                      disabled={isLoading}
                      checked={values.onlyUnread}
                      onChange={handleChange}
                    />
                  </ChecklistContainer>
                </Grid.Column>

                <Grid.Column
                  width={4}
                  verticalAlign={'bottom'}
                  textAlign={'right'}
                  floated="right"
                  style={{ display: 'flex', flexDirection: 'row' }}
                >
                  {user.role && user.role.includes('BROKER') && (
                    <Button
                      light
                      disabled={isLoading}
                      fluid
                      type="button"
                      onClick={() => {
                        handleExportData(values);
                      }}
                      content={'Exportar'}
                    />
                  )}

                  <Button
                    light
                    fluid
                    onClick={handleReset}
                    content={'Limpar'}
                    disabled={isLoading}
                    type="button"
                  />

                  <Button
                    fluid
                    disabled={isLoading}
                    type="submit"
                    content={'Pesquisar'}
                  />
                </Grid.Column>
              </Grid.Row>
              {!user.role!.includes('ESTATE') && (
                <Grid.Row>
                  <FilteredColumn width={2} onClick={() => handleChangeBadge('new')}>
                    <LabelBadge color="#6FCA7D" />{' '}
                    <SpanNumBadge checked={filters?.isNew}>
                      {statusCount.countNew !== undefined
                        ? `(${statusCount.countNew})`
                        : ''}
                    </SpanNumBadge>
                    <DivTextBadge checked={filters?.isNew}>Novos sinistros</DivTextBadge>
                  </FilteredColumn>
                  <FilteredColumn
                    width={2}
                    borderLeft
                    onClick={() => handleChangeBadge('unread')}
                  >
                    <LabelBadge color="#00A2DD" />{' '}
                    <SpanNumBadge checked={filters?.isUnread}>
                      {statusCount.countUnread !== undefined
                        ? `(${statusCount.countUnread})`
                        : ''}
                    </SpanNumBadge>
                    <DivTextBadge checked={filters?.isUnread}>Não lidos</DivTextBadge>
                  </FilteredColumn>
                  <FilteredColumn
                    width={2}
                    borderLeft
                    onClick={() => handleChangeBadge('old')}
                  >
                    <LabelBadge color="#ECA800" />{' '}
                    <SpanNumBadge checked={filters?.isOld}>
                      {statusCount.countOld !== undefined
                        ? `(${statusCount.countOld})`
                        : ''}
                    </SpanNumBadge>
                    <DivTextBadge checked={filters?.isOld}>
                      Solicitados há 7 dias ou mais
                    </DivTextBadge>
                  </FilteredColumn>
                  <FilteredColumn
                    width={2}
                    borderLeft
                    onClick={() => handleChangeBadge('draft')}
                  >
                    <LabelBadge color="#59249B" />{' '}
                    <SpanNumBadge checked={filters?.claimEstateStatus === 'DRAFT'}>
                      {statusCount.countDraft !== undefined
                        ? `(${statusCount.countDraft})`
                        : ''}
                    </SpanNumBadge>
                    <DivTextBadge checked={filters?.claimEstateStatus === 'DRAFT'}>
                      Rascunhos
                    </DivTextBadge>
                  </FilteredColumn>
                </Grid.Row>
              )}
            </Grid>
          </form>
        )}
      </Formik>

      <Table celled>
        <Table.Header fullWidth>
          <Table.Row>
            <SortableHeaderCell columnKey="createdAt">Solicitado em</SortableHeaderCell>
            <SortableHeaderCell columnKey="updatedAt">
              Data de atualização
            </SortableHeaderCell>
            <SortableHeaderCell columnKey="insurerName">Seguradora</SortableHeaderCell>
            <SortableHeaderCell columnKey="estateName">Imobiliária</SortableHeaderCell>
            <SortableHeaderCell columnKey="tenantName">Inquilino</SortableHeaderCell>
            <SortableHeaderCell columnKey="propertyStreet">Endereço</SortableHeaderCell>
            <SortableHeaderCell columnKey="status">Status</SortableHeaderCell>
            <SortableHeaderCell columnKey="unreadMessagesCount">Ações</SortableHeaderCell>
          </Table.Row>
        </Table.Header>
        <Dimmer.Dimmable as={Table.Body} dimmed={isLoading}>
          {isLoading && (
            <Dimmer active blurring>
              <Loader />
            </Dimmer>
          )}
          {data.length > 0 ? (
            <>
              {data.map((item: any) => {
                const {
                  id,
                  createdAt,
                  updatedAt,
                  status,
                  insurerName,
                  estateName,
                  tenantName,
                  tenantDocument,
                  propertyStreet,
                  propertyNumber,
                  propertyComplement,
                  propertyDistrict,
                  propertyCity,
                  propertyState,
                  propertyStatus,
                  unreadMessagesCount,
                  estateResponsible
                } = item;

                const fullAddress = `${propertyStreet}, ${propertyNumber}${
                  propertyComplement ? ` ${propertyComplement}` : ''
                } - ${propertyDistrict} - ${propertyCity} - ${propertyState}`;
                const address = `${propertyStreet}, ${propertyNumber}${
                  propertyComplement ? ` ${propertyComplement}` : ''
                }`;
                const popupAddress = () => (
                  <>
                    <span>{fullAddress}</span>
                    <br />
                    <strong>Imóvel {translatePropertyStatus(propertyStatus)}</strong>{' '}
                    <Icon
                      name={'circle'}
                      color={propertyStatus === 'OCCUPIED' ? 'red' : 'green'}
                    />
                  </>
                );

                // Remove o timezone da string e trata como UTC antes de converter para o timezone local
                const createdAtWithoutTimezone = createdAt?.replace(
                  /[+-]\d{2}:\d{2}$/,
                  ''
                );
                const createdAtFormatted = moment
                  .utc(createdAtWithoutTimezone)
                  .tz('America/Sao_Paulo')
                  .format(`DD/MM/YYYY HH:mm`)
                  .split(' ');
                const updatedAtWithoutTimezone = updatedAt?.replace(
                  /[+-]\d{2}:\d{2}$/,
                  ''
                );
                const updatedAtFormatted = updatedAt
                  ? moment
                      .utc(updatedAtWithoutTimezone)
                      .tz('America/Sao_Paulo')
                      .format(`DD/MM/YYYY HH:mm`)
                      .split(' ')
                  : ' - ';
                return (
                  <>
                    <ClickableTableRow key={id!}>
                      <ClickableTableCell
                        onClick={() => openDetailModal(id)}
                        textAlign={'center'}
                        collapsing
                      >
                        {createdAtFormatted[0]} <br /> {createdAtFormatted[1]}
                      </ClickableTableCell>
                      <ClickableTableCell
                        onClick={() => openDetailModal(id)}
                        textAlign={'center'}
                        collapsing
                      >
                        {updatedAtFormatted[0]} <br /> {updatedAtFormatted[1]}
                      </ClickableTableCell>
                      <ClickableTableCell
                        onClick={() => openDetailModal(id)}
                        textAlign={'center'}
                        width={2}
                        style={{
                          textOverflow: 'ellipsis',
                          wordWrap: 'nowrap'
                        }}
                      >
                        {insurerName}
                      </ClickableTableCell>
                      <ClickableTableCell
                        onClick={() => openDetailModal(id)}
                        textAlign={'center'}
                      >
                        {estateName}
                      </ClickableTableCell>
                      <ClickableTableCell
                        onClick={() => openDetailModal(id)}
                        textAlign={'center'}
                      >
                        {tenantName}
                        <br />
                        <span style={{ color: '#777' }}>
                          ({maskCpfOrCnpj(tenantDocument)})
                        </span>
                      </ClickableTableCell>
                      <ClickableTableCell
                        onClick={() => openDetailModal(id)}
                        style={{ cursor: 'default' }}
                        textAlign={'center'}
                      >
                        <Popup
                          content={popupAddress}
                          as={Segment}
                          style={{ border: '2px solid #dfdfdf' }}
                          position={'left center'}
                          trigger={
                            <span style={{ cursor: 'help' }}>
                              {address}
                              <br />
                              <span style={{ color: '#777' }}>
                                ({translatePropertyStatus(propertyStatus)})
                              </span>
                            </span>
                          }
                        />
                      </ClickableTableCell>
                      <ClickableTableCell
                        onClick={() => openDetailModal(id)}
                        textAlign={'center'}
                      >
                        {estateResponsible && (
                          <Popup
                            trigger={
                              <span style={{ marginRight: 6 }}>
                                <IconButton name="user" size="large" />
                              </span>
                            }
                            content={estateResponsible.name}
                          />
                        )}
                        {translateStatus(status)}
                      </ClickableTableCell>
                      <Table.Cell>
                        <Menu compact>
                          {status !== ClaimEstatesStatusEnum.draft && (
                            <Menu.Item>
                              <Button
                                primary
                                icon="chat"
                                onClick={() => {
                                  handleClaimUpdatesList(id, item, status);
                                }}
                              />
                              {unreadMessagesCount != 0 && (
                                <Label color="red" circular floating>
                                  {unreadMessagesCount}
                                </Label>
                              )}
                            </Menu.Item>
                          )}
                          {status === ClaimEstatesStatusEnum.draft ? (
                            <>
                              <Button
                                style={{ margin: 0 }}
                                type="button"
                                color="blue"
                                onClick={() => {
                                  setDraftIdToResume(id);
                                }}
                              >
                                <Icon name={'play'} />
                                Retomar Sinistro
                              </Button>
                              <AuthorizationContainer
                                action={ActionEnum.delete}
                                feature={FeatureEnum.claims}
                              >
                                <Button
                                  style={{ margin: 0, marginLeft: 8 }}
                                  type="button"
                                  color="red"
                                  disabled={isDeletingDraft}
                                  onClick={() => setDraftToDelete(id)}
                                >
                                  <Icon name="trash" />
                                  Excluir rascunho
                                </Button>
                              </AuthorizationContainer>
                            </>
                          ) : (
                            <Menu.Item>
                              <Dropdown trigger={trigger} icon={null} direction="left">
                                <Dropdown.Menu style={{ zIndex: 1000 }}>
                                  <>
                                    <Dropdown.Item>
                                      <ModalAttachFiles
                                        message={`A inserção de documentos é obrigatória para a abertura do sinistro.`}
                                        trigger={
                                          <Button type="button" color="teal">
                                            <Icon name={'attach'} />
                                            Gerenciar Anexos
                                          </Button>
                                        }
                                        bondInsuranceId={id}
                                        tableName={'CLAIM_ESTATES'}
                                        fileIdentifiers={FileIdentifiersAll}
                                        callback={(data, files) =>
                                          callback(data, files, id)
                                        }
                                        brokerOnly={true}
                                        tenantName={tenantName}
                                        disabled={
                                          status === ClaimEstatesStatusEnum.finished
                                        }
                                      />
                                    </Dropdown.Item>
                                    {user.role.includes('ESTATE') && (
                                      <AuthorizationContainer
                                        action={ActionEnum.assignEstateResponsible}
                                        feature={FeatureEnum.claims}
                                      >
                                        <Dropdown.Item>
                                          <Button
                                            style={{ cursor: 'pointer' }}
                                            fluid={true}
                                            type="button"
                                            color="purple"
                                            onClick={() => {
                                              setSelectedItem(item);
                                              setOpenSetEstateResponsible(true);
                                            }}
                                          >
                                            <Icon name="user" />
                                            {estateResponsible
                                              ? 'Alterar responsável'
                                              : 'Atribuir responsável'}
                                          </Button>
                                        </Dropdown.Item>
                                      </AuthorizationContainer>
                                    )}
                                    {
                                      //status !== "FINISHED" &&
                                      !user.role!.includes('ESTATE') && (
                                        <AuthorizationContainer
                                          action={ActionEnum.update}
                                          feature={FeatureEnum.claims}
                                        >
                                          <Dropdown.Item>
                                            <Button
                                              style={{ cursor: 'pointer' }}
                                              fluid={true}
                                              type="button"
                                              color="yellow"
                                              onClick={() => {
                                                handleEdit(id);
                                              }}
                                            >
                                              <Icon name={'pencil alternate'} />
                                              Editar
                                            </Button>
                                          </Dropdown.Item>
                                          <Dropdown.Item>
                                            <Button
                                              style={{ cursor: 'pointer' }}
                                              fluid={true}
                                              type="button"
                                              color="orange"
                                              onClick={() => {
                                                setCloneIdToClone(id);
                                              }}
                                            >
                                              <Icon name={'clone'} />
                                              Clonar
                                            </Button>
                                          </Dropdown.Item>
                                          {propertyStatus ===
                                            ClaimPropertyStatusEnum.occupied && (
                                            <Dropdown.Item>
                                              <Button
                                                style={{ cursor: 'pointer' }}
                                                fluid={true}
                                                type="button"
                                                color="brown"
                                                onClick={() => {
                                                  handleVacate(id, insurerName);
                                                }}
                                              >
                                                <Icon name={'reply'} />
                                                Desocupar imóvel
                                              </Button>
                                            </Dropdown.Item>
                                          )}
                                        </AuthorizationContainer>
                                      )
                                    }
                                  </>
                                </Dropdown.Menu>
                              </Dropdown>
                            </Menu.Item>
                          )}
                        </Menu>
                      </Table.Cell>
                    </ClickableTableRow>
                  </>
                );
              })}
            </>
          ) : (
            <Table.Row>
              <Table.Cell colSpan={9} textAlign={'center'}>
                <span>{getListEmptyMessage(props.user?.role, props.user?.estateUnitId)}</span>
              </Table.Cell>
            </Table.Row>
          )}
        </Dimmer.Dimmable>
        <Table.Footer fullWidth>
          <Table.Row>
            <Table.HeaderCell colSpan={9} textAlign={'right'}>
              {!isLoading && (
                <TablePaginationMenu
                  currentPage={currentPage}
                  dataCount={count}
                  setCurrentPage={setCurrentPage}
                />
              )}
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      </Table>
      <DetailModal open={openDetail} claimId={id} close={() => setOpenDetail(false)} />
      <EditClaimEstateModal
        users={users!}
        claimId={id}
        open={isEditModalIsOpen}
        close={() => setEditModalIsOpen(false)}
      />
      {openCreateClaimModal && selectedPolicyForClaim && (
        <CreateClaimEstateModal
          onlyModal={true}
          policy={selectedPolicyForClaim}
          onClose={() => {
            setOpenCreateClaimModal(false);
            setSelectedPolicyForClaim(null);
            getData();
          }}
        />
      )}

      {draftIdToResume && (
        <CreateClaimEstateModal
          onlyModal={true}
          draftId={draftIdToResume}
          onClose={() => {
            setDraftIdToResume(null);
            getData(); // Refresh table
          }}
        />
      )}

      {cloneIdToClone && (
        <CreateClaimEstateModal
          onlyModal={true}
          cloneId={cloneIdToClone}
          onClose={() => {
            setCloneIdToClone(null);
            getData(); // Refresh table
          }}
        />
      )}

      {openSetEstateResponsible && selectedItem && (
        <SetEstateResponsibleModal
          isOpen={openSetEstateResponsible}
          onClose={() => setOpenSetEstateResponsible(false)}
          claimId={selectedItem.id}
          estateId={
            selectedItem.estateId ||
            user?.estate?.id ||
            availableBrokersAndEstates?.activeEstateId
          }
          responsible={selectedItem.estateResponsible?.id || null}
          onSuccess={() => getData()}
        />
      )}

      {openVacateModal && (
        <VacatePropertyClaimModal
          fileIdentifiers={getFileIdentifiers({
            values: {
              claimProperty: {
                status: ClaimPropertyStatusEnum.vacant
              }
            }
          } as any)}
          claimId={claimVacate ? claimVacate.id : ''}
          insurerName={claimVacate ? claimVacate.insurerName : ''}
          onClose={() => setOpenVacateModal(false)}
          callback={() => getData()}
        />
      )}

      <PopupModal locationActivation={BannerLocationActivationEnum.CLAIM_LIST} />
    </>
  );
};
export default connect(mapState, mapDispatch)(ClaimTable);
